import React, { useEffect, useCallback } from 'react';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { formGradimentoService } from '../../services/FormGradimento/FormGradimentoService';
import { useTranslation } from '../../i18n/LanguageContext';


function HomePage() {
  const { user, isAdmin, isModerator, isUser, isSchool, isHostingPartner, logout } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  /*const [loading, setStatoCaricamento] = useState(true);
  const [messaggioCaricamento, setMessaggioCaricamento] = useState("Caricamento in corso...");*/

  /*const setCaricamento = (isLoading, messaggio = "") => {
    setStatoCaricamento(isLoading);
    setMessaggioCaricamento(messaggio);
  };*/

  
  // Operazioni per utenti non autenticati
  const operazioniNonAutenticato = [
    { id: 1, titolo: t('homepage.operations.login.title'), descrizione: t('homepage.operations.login.description'), path: '/login' },
    { id: 2, titolo: t('homepage.operations.register.title'), descrizione: t('homepage.operations.register.description'), path: '/registrami' },
  ];

  // Operazioni per utenti normali (ROLE_USER)
  const operazioniUser = [
    { id: 1, titolo: t('homepage.operations.listForm.title'), descrizione: t('homepage.operations.listForm.description'), path: '/listaForm' },
    { id: 2, titolo: t('homepage.operations.intermediateEvaluation.title'), descrizione: t('homepage.operations.intermediateEvaluation.description'), path: '/homepageValutazioni', disabilitato: false },
  ];

  // Operazioni per moderatori (ROLE_MODERATOR)
  const operazioniModerator = [
    { id: 1, titolo: t('homepage.operations.listForm.title'), descrizione: t('homepage.operations.listForm.description'), path: '/listaForm' },
    //{ id: 2, titolo: 'Visualizza Candidati', descrizione: 'Visualizza la lista dei candidati', path: '/tab' },
    //{ id: 3, titolo: 'Gestione Risposte', descrizione: 'Gestisci le risposte degli utenti', path: '/formRisposta' },
  ];

  // Operazioni per scuole (ROLE_SCHOOL)
  const operazioniSchool = [
    { id: 1, titolo: t('homepage.operations.listForm.title'), descrizione: t('homepage.operations.listForm.description'), path: '/listaForm' },
    //{ id: 2, titolo: 'Gestione Studenti', descrizione: 'Gestisci le candidature degli studenti', path: '/form' },
    //{ id: 3, titolo: 'Visualizza Risposte', descrizione: 'Visualizza le risposte dei form', path: '/formRisposta' },
  ];

  // Operazioni per hosting partner (ROLE_HOSTING_PARTNER)
  const operazioniHostingPartner = [
    //{ id: 1, titolo: 'Gestione Form Backoffice', descrizione: 'Gestisci i form disponibili lato amministrativo', path: '/listaFormBackoffice' },
    { id: 2, titolo: t('homepage.operations.candidatesList.title'), descrizione: t('homepage.operations.candidatesList.description'), path: '/listaCandidati_partner' },
    //{ id: 3, titolo: 'Gestione Partner', descrizione: 'Gestisci i partner della piattaforma', path: '/partner' },
    //{ id: 4, titolo: 'Gestione Progetti', descrizione: 'Gestisci i progetti disponibili', path: '/project' },
    { id: 5, titolo: t('homepage.operations.subprojectsManagement.title'), descrizione: t('homepage.operations.subprojectsManagement.description'), path: '/gestioneSottoProgetti_partner' },
    { id: 6, titolo: t('homepage.operations.evaluationsManagement.title'), descrizione: t('homepage.operations.evaluationsManagement.description'), path: '/gestioneValutazioni_partner' },
  ];

  // Operazioni per amministratori (ROLE_ADMIN)
  const operazioniAdmin = [
    { id: 1, titolo: t('homepage.operations.backofficeFormsManagement.title'), descrizione: t('homepage.operations.backofficeFormsManagement.description'), path: '/listaFormBackoffice' },
    { id: 2, titolo: t('homepage.operations.candidatesList.title'), descrizione: t('homepage.operations.candidatesList.description'), path: '/tab' },
    { id: 3, titolo: t('homepage.operations.partnerManagement.title'), descrizione: t('homepage.operations.partnerManagement.description'), path: '/partner' },
    { id: 4, titolo: t('homepage.operations.projectsManagement.title'), descrizione: t('homepage.operations.projectsManagement.description'), path: '/project' },
    { id: 5, titolo: t('homepage.operations.subprojectsManagement.title'), descrizione: t('homepage.operations.subprojectsManagement.description'), path: '/subProject' },
    { id: 6, titolo: t('homepage.operations.evaluationsManagement.title'), descrizione: t('homepage.operations.evaluationsManagement.description'), path: '/monitorValutazioni' },
    //{ id: 6, titolo: 'Visualizza Risposte', descrizione: 'Visualizza tutte le risposte degli utenti', path: '/formRisposta' },
  ];


  /*useEffect(() => {
    const possoInviareFeedbackIntermedio = async () => {

      // Verifichiamo che idUtente esista prima di procedere
      if (user && !idUtente) return;

      try {
        setCaricamento(true, "Caricamento...");

        let localIdUtente = localStorage.getItem('id');

        // Chiamata al servizio formGradimentoService
        const risposta = await formGradimentoService.possoInviareFeedbackIntermedio(localIdUtente);

        // Se il messaggio non è vuoto, aggiorna le operazioni per gli utenti
        if (risposta && risposta.trim() !== "") {
          if (risposta == "Hai già compilato il form del feedback intermedio") {
            setOperazioniUser(prevOps => {
              // Crea una copia dell'array
              const newOps = [...prevOps];
              // Trova l'indice dell'operazione Form gradimento
              const formGradimentoIndex = newOps.findIndex(op => op.id === 2);
              if (formGradimentoIndex !== -1) {
                // Aggiorna l'operazione mantenendo invariati gli altri campi
                newOps[formGradimentoIndex] = {
                  ...newOps[formGradimentoIndex],
                  descrizione: "Visualizza le tue risposte",
                  //path: '/riepilogoValutazioneIntermedia',
                  disabilitato: false
                };
              }
              return newOps;
            });

          } else {
            setOperazioniUser(prevOps => {
              // Crea una copia dell'array
              const newOps = [...prevOps];
              // Trova l'indice dell'operazione Form gradimento
              const formGradimentoIndex = newOps.findIndex(op => op.id === 2);
              if (formGradimentoIndex !== -1) {
                // Aggiorna l'operazione mantenendo invariati gli altri campi
                newOps[formGradimentoIndex] = {
                  ...newOps[formGradimentoIndex],
                  descrizione: risposta,
                  disabilitato: true
                };
              }
              return newOps;
            });
          }
          
        }

        setCaricamento(false);
      } catch (error) {
        console.error("Errore durante il caricamento dei dati:", error);

        setCaricamento(false);
      }
    };
    
    possoInviareFeedbackIntermedio();
  }, [idUtente]);*/ // idUtente come dipendenza

  const controllaValiditàToken = useCallback(async () => {
    const token = localStorage.getItem('token');
    
    if (!token) {
      return;
    }

    try {
      await formGradimentoService.caricaDatiIniziali();
      //Token valido
    } catch (error) {
      // Token non valido
      logout();
    } 
  }, [logout]);

  useEffect(() => {
    controllaValiditàToken();
  }, [controllaValiditàToken]);


  // Determina quali operazioni mostrare in base al ruolo dell'utente
  const getOperazioniByRole = () => {
    if (!user) return operazioniNonAutenticato;
    
    if (isAdmin()) return operazioniAdmin;
    if (isModerator()) return operazioniModerator;
    if (isSchool()) return operazioniSchool;
    if (isHostingPartner()) return operazioniHostingPartner;
    if (isUser()) return operazioniUser;
    
    // Default case
    return operazioniUser;
  };
  const operazioni = getOperazioniByRole();


  // Funzione per navigare alla pagina dell'operazione selezionata
  const handleOperazioneClick = (path, disabilitato) => {
    // Se l'operazione è disabilitata, non navigare
    if (disabilitato) {
      return;
    }
    navigate(path);
  };
  
  return (
    <Container maxWidth="lg">
      <Box sx={{ my: { xs: 2, sm: 4 }, textAlign: 'center' }}>
        <Typography variant="h3" component="h1" gutterBottom sx={{ fontSize: { xs: '1.8rem', md: '3rem' } }}>
          {t('homepage.title')}
        </Typography>

        {user ? (
          <>
            <Typography variant="h6" sx={{ mb: { xs: 2, sm: 4 } }}>
              {t('homepage.welcomeBack').replace('{username}', user.username)}
            </Typography>

            {/* Griglia di operazioni */}
            <Grid container spacing={{ xs: 2, sm: 3 }}>
              {operazioni.map((operazione) => (
                <Grid item xs={12} sm={6} key={operazione.id}>
                  <Paper
                    elevation={3}
                    sx={{
                      p: { xs: 2, sm: 3 },
                      backgroundColor: operazione.disabilitato ? '#a0a0a0' : '#1d659c',
                      color: 'white',
                      height: '100%',
                      cursor: operazione.disabilitato ? 'not-allowed' : 'pointer',
                      transition: 'all 0.3s',
                      '&:hover': {
                        transform: operazione.disabilitato ? 'none' : 'translateY(-4px)',
                        boxShadow: operazione.disabilitato ? 1 : 6,
                      },
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      textAlign: 'center',
                    }}
                    onClick={() => handleOperazioneClick(operazione.path, operazione.disabilitato)}
                  >
                    <Typography variant="h5" component="h2" gutterBottom>
                      {operazione.titolo}
                    </Typography>
                    <Typography variant="body1">
                      {operazione.descrizione}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </>
        ) : (
          <>
            <Box sx={{ mt: { xs: 2, sm: 4 }, p: { xs: 2, sm: 4 }, backgroundColor: '#f5f5f5', borderRadius: 2, mb: { xs: 2, sm: 4 } }}>
              <Typography variant="h6" gutterBottom>
                {t('homepage.loginPrompt')}
              </Typography>
              <Typography variant="body1">
                {t('homepage.loginPromptDescription')}
              </Typography>
            </Box>

            {/* Griglia di operazioni per utenti non autenticati */}
            <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 3 }}>
              {operazioni.map((operazione) => (
                <Box key={operazione.id} sx={{ width: { xs: '100%', sm: 320 } }}>
                  <Paper
                    elevation={3}
                    sx={{
                      p: { xs: 2, sm: 3 },
                      backgroundColor: '#1d659c',
                      color: 'white',
                      height: '100%',
                      cursor: 'pointer',
                      transition: 'all 0.3s',
                      '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: 6,
                      },
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      textAlign: 'center',
                    }}
                    onClick={() => handleOperazioneClick(operazione.path)}
                  >
                    <Typography variant="h5" component="h2" gutterBottom>
                      {operazione.titolo}
                    </Typography>
                    <Typography variant="body1">
                      {operazione.descrizione}
                    </Typography>
                  </Paper>
                </Box>
              ))}
            </Box>
          </>
        )}
      </Box>

      {/* Spinner di caricamento 
      <Backdrop
        sx={{
          color: '#ffffff',
          zIndex: 999,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        open={loading}
      >
        <CircularProgress
          color="inherit"
          size={100}
          thickness={4}
          style={{ marginBottom: '16px' }}
        />
        {messaggioCaricamento && (
          <Typography variant="h6" component="div">
            {messaggioCaricamento}
          </Typography>
        )}
      </Backdrop>*/}

    </Container>
  );
}

export default HomePage;